module.exports = __webpack_public_path__ + "static/img/baby-weigh.5b17f81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/Uphc/Uphc-pics/baby-weigh.jpg
// module id = xg8S
// module chunks = 0